module.exports = __webpack_public_path__ + "img/free-plan.e03b1de1.png";